import { createRef, useEffect } from 'react';
import { computed, observable } from 'mobx';
import { autobind } from 'core-decorators';
import useUnmount from '@src/utils/hooks/use-unmount';

export default class EmailTipsStore {
  /**
   *
   * @type {React.RefObject<HTMLInputElement>}
   */
  inputRef = createRef();
  /**
   *
   * @type {React.RefObject<HTMLDivElement>}
   */
  listRef = createRef();
  @observable active = false;
  list = [
    'gmail.com',
    'hotmail.com',
    'icloud.com',
    'naver.com',
    'yahoo.com',
    'yahoo.co.jp',
    'outlook.com',
    'mail.ru',
    'qq.com',
    'ezweb.ne.jp',
    'i.softbank.jp',
    'docomo.ne.jp',
    'outlook.jp',
    'yandex.ru',
    'live.com',
    'hotmail.co.jp',
    'au.com',
    '163.com',
    'web.de',
    'gmx.de',
    'protonmail.com'
  ];
  @observable inputValue = '';
  @observable value = '';
  @observable num = -1;

  /**
   *
   *
   */
  @computed
  get emailDefaultList() {
    if (typeof this.inputValue !== 'string') {
      return [];
    }
    const value = this.inputValue.split('@')[0];
    return this.list.map(domain => ({
      label: `${value}@${domain}`,
      value: `${value}@${domain}`
    }));
  }

  onChange(value) {}

  @autobind
  onClick(value) {
    this.onChange(value);
    this.value = { value };
    this.active = false;
  }

  /**
   * @return {{label: string, value: string}[]}
   */
  @computed
  get emailList() {
    return this.emailDefaultList.filter(option => option.value.match(this.inputValue));
  }
  use() {
    useEffect(
      () => {
        const keyDown = e => {
          const keyNum = window.event ? e.keyCode : e.which;
          switch (keyNum) {
            case 38:
              if (this.num) {
                this.num--;
              }
              break;
            case 40:
              if (this.num < this.emailList.length - 1) {
                this.num++;
              }
              break;
            case 13:
              if (this.emailList[this.num] && this.emailList[this.num].value) {
                this.value = { value: this.emailList[this.num].value };
                this.active = false;
              }
              break;
            default:
          }
        };
        document.addEventListener('keydown', keyDown, false);
        return () => {
          document.removeEventListener('keydown', keyDown, false);
        };
      },
      [this.num, this.emailList.length]
    );
    useUnmount(() => {
      this.num = -1;
    });
    useEffect(
      () => {
        this.num = -1;
      },
      [this.inputValue]
    );
    useEffect(
      () => {
        if (this.listRef.current) {
          const wheelHandler = e => {
            e.stopImmediatePropagation();
            e.stopPropagation();
          };
          this.listRef.current.addEventListener('wheel', wheelHandler, false);
          return () => {
            // this.listRef.current.removeEventListener('wheel', wheelHandler, false);
          };
        }
      },
      [this.listRef.current]
    );
    useEffect(
      () => {
        if (this.listRef.current) {
          const item = this.listRef.current.childNodes[this.num];
          if (item) {
            item.scrollIntoView({
              block: 'nearest'
            });
          }
        }
      },
      [this.num, this.listRef.current]
    );
    useEffect(
      () => {
        const keyPress = e => {
          const value = e.target.value;
          this.inputValue = value;
        };
        if (this.inputRef.current) {
          console.log(this.inputRef.current);
          this.inputRef.current.addEventListener('keypress', keyPress);
          return () => {
            this.inputRef.current.removeEventListener('keypress', keyPress);
          };
        }
      },
      [this.inputRef.current]
    );
  }
}
